module.exports = __webpack_public_path__ + "static/media/php.90ca90ad.png";